import { ISavedView } from '@opengov/reporting-types/src/reportSavedView';

export function isTitleDuplicate(title: string, existingSavedViews?: ISavedView[], excludeId?: string): boolean {
  if (!existingSavedViews || !title.trim()) {
    return false;
  }
  const normalizedTitle = title.trim().toLowerCase();
  return existingSavedViews.some((view) => view.title.toLowerCase() === normalizedTitle && view.id !== excludeId);
}
